import { useEffect, useState } from "react";

import jwt_decode from "jwt-decode";
import { EmailGoogleAuthAPICall } from "../../shared/APICalls";
import routesData from "../../shared/routes.json";
import { useNavigate, useLocation } from "react-router-dom";
import { round } from "face-api.js/build/commonjs/utils";
// import GoogleLoginButton from "./components/GoogleLoginButton";

function ContinueWithGoogle({ handleCallBack }) {
  const [user, setUser] = useState({});

  const navigationData = routesData;
  const navigate = useNavigate();

  const handleCallBackResponse = (response) => {
    // console.log("JWT ID: " + response.credential);

    const userObject = jwt_decode(response.credential);

    // console.log(userObject);

    setUser(userObject);
    let obj = {
      email: userObject.email,
      google_client_id: userObject.aud,
    };
    sessionStorage.setItem("client-name", userObject.given_name);
    sessionStorage.setItem("client-email", userObject.email);
    EmailGoogleAuthAPICall(obj)
      .then((response) => {
        const responseData = response.data;
        //  console.log(response, "response");

        // if (
        //   responseData.data.next_stage &&
        //   navigationData.hasOwnProperty(responseData.data.next_stage)
        // ) {
        //   navigate(navigationData[responseData.data.next_stage]);
        // }
      })
      .catch((error) => {
        if (error.response.data.message) {
          handleCallBack(error.response.data.message);

          setTimeout(() => {
            handleCallBack("");
          }, 5000);
        }
      });
  };

  useEffect(() => {
    // global google

    window.google.accounts.id.initialize({
      client_id:
        "1085784227894-t9v8aa1dok1ft3i90r8r4rfokr4nslvr.apps.googleusercontent.com",

      callback: handleCallBackResponse,
    });

    window?.google?.accounts?.id.renderButton(
      document.getElementById("signup"),
      {
        theme: "filled_white",
        shape: "pill",
        width: "240",
        size: "large",
        longtitle: true,
        height: 60,

      }
    );
  }, []);

  return (
    <>
      {/* <GoogleLoginButton /> */}

      <div
        id="signup"
        data-width="240"
        data-height="60"
        data-longtitle="true"
        style={{ borderRadius: "100" }}
      >
        {user && (
          <div>
            <img src={user.picture} alt="User" />

            <h3>{user.name}</h3>
          </div>
        )}
      </div>
    </>
  );
}

export default ContinueWithGoogle;
